import { useNavigate } from "react-router-dom";
import FacebookGallery from "./FacebookGallery";
import PageMeta from "./PageMeta";

export default function GalleryPage() {
  const navigate = useNavigate();

  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="Photo Gallery | Redruth Sea Angling Association"
        description="Photos from Redruth Sea Angling Association competitions, catches and club events around the Cornish coast."
        keywords="RSAA photo gallery, sea angling club photos Cornwall, Redruth Sea Angling Association gallery"
        url="https://www.redruthseaanglingassociation.co.uk/gallery"
      />
      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-8 flex items-center gap-4">
          <button type="button" onClick={() => navigate(-1)}
            className="standalone-only group inline-flex items-center gap-1.5 rounded-full border border-cyan-400/20 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 shadow-lg shadow-black/20 backdrop-blur transition hover:-translate-x-0.5 hover:border-cyan-300/40 hover:bg-cyan-400/10 hover:text-white">
            ← Back
          </button>
          <div>
            <h1 className="heading-glow text-2xl font-bold text-white sm:text-3xl">Photo Gallery</h1>
            <p className="mt-1 text-sm text-slate-400">Photos from the RSAA Facebook page</p>
          </div>
        </div>

        <FacebookGallery />
      </div>
    </div>
  );
}
